if (!customElements.get("product-slider")) {
  class ProductSlider extends HTMLElement {
    connectedCallback() {
      if (this.swiper) {
        return;
      }

      this.swiper = new Swiper(this.querySelector(".swiper"), {
        direction: "horizontal",
        loop: false,
        spaceBetween: 10,
        slidesOffsetBefore: 14,
        slidesPerView: 1.5,
        watchOverflow: true,
        navigation: {
          prevEl: this.querySelector(".product-slider__arrow--prev"),
          nextEl: this.querySelector(".product-slider__arrow--next"),
        },
        pagination: {
          el: this.querySelector(".product-slider__pagination"),
          clickable: true,
        },
        breakpoints: {
          990: {
            spaceBetween: 18,
            slidesOffsetBefore: 0,
            slidesPerView: 4,
          },
        },
      });
    }

    disconnectedCallback() {
      if (!this.swiper) {
        return;
      }

      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  customElements.define("product-slider", ProductSlider);
}
